var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7803 0.816584C16.1539 0.219993 15.1383 0.219993 14.5118 0.816584L2.62768 12.1348C2.42545 12.3274 2.28097 12.568 2.2092 12.8317L1.01825 17.2066C0.744938 18.2106 1.56956 19.1346 2.58936 19.119C2.59488 19.1191 2.60041 19.1191 2.60596 19.1191H19.9966C20.359 19.1191 20.6528 18.8393 20.6528 18.4941C20.6528 18.149 20.359 17.8691 19.9966 17.8691H7.7733C7.96926 17.7926 8.14805 17.6795 8.29886 17.536L20.183 6.2177C20.8094 5.62111 20.8094 4.65386 20.183 4.05727L16.7803 0.816584ZM19.255 4.94114L15.8522 1.70047C15.7384 1.59203 15.5538 1.59203 15.4399 1.70047L13.139 3.89177L16.9541 7.52511L19.255 5.33383C19.3688 5.22539 19.3688 5.04958 19.255 4.94114ZM16.026 8.40901L12.211 4.77567L3.55575 13.0187C3.519 13.0537 3.49274 13.0975 3.47969 13.1454L2.28875 17.5203C2.23295 17.7253 2.42891 17.9119 2.64414 17.8587L7.23777 16.7245C7.2881 16.7121 7.33401 16.6871 7.37076 16.6521L16.026 8.40901Z",
    fill: "#1467B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.bb0a7610949fccd4f72b2383e6b482b0.svg";
export { ForwardRef as ReactComponent };